module.exports = __webpack_public_path__ + "static/img/6.1f73b83.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/sp/6.png
// module id = BwGG
// module chunks = 0